// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1__pF","cls2":"Accordion-cls2_Lne Accordion-cls1__pF"};